var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4038 0.862254C14.6641 1.1226 14.6641 1.54471 14.4038 1.80506L13.5419 2.66699L15.0705 4.19559C15.3308 4.45594 15.3308 4.87805 15.0705 5.1384L12.7371 7.47173C12.4768 7.73208 12.0547 7.73208 11.7943 7.47173L10.2657 5.94313L8.44793 7.76093C9.72061 9.43889 9.56495 11.8397 8.08129 13.394C6.41465 15.14 3.65855 15.1242 1.93874 13.4826C1.93469 13.4787 1.93069 13.4748 1.92675 13.4708L1.86098 13.4051L1.85015 13.394C0.194901 11.6599 0.276922 8.91298 1.92765 7.26225C1.93513 7.25478 1.94278 7.24748 1.95061 7.24037C3.50032 5.83153 5.8247 5.68395 7.48555 6.83769L13.461 0.862254C13.7213 0.601905 14.1434 0.601905 14.4038 0.862254ZM12.5991 3.6098L11.2085 5.00033L12.2657 6.05752L13.6562 4.66699L12.5991 3.6098ZM7.07136 8.21522C5.93819 7.13731 4.07758 7.11976 2.8593 8.21628C1.72256 9.36507 1.67373 11.2723 2.80953 12.468L2.86472 12.5232C4.07851 13.6764 5.98512 13.6589 7.11682 12.4733C8.27465 11.2604 8.25942 9.35102 7.07371 8.21746L7.07136 8.21522Z",
    fill: "#787A84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.28658e9d.svg";
export { ForwardRef as ReactComponent };